import DailySpin from './DailySpin';

export default DailySpin;
